import * as yup from 'yup'

import { IBaseCostFormValues } from 'features/PartnerCost/types'
import { defineMessages, IntlShape } from 'react-intl'

const amountMessages = defineMessages({
  required: {
    id: 'partnerCost.form.baseCosts.amount.required',
    defaultMessage: 'This amount is required'
  }
})

const noteMessages = defineMessages({
  required: {
    id: 'partnerCost.form.note.required',
    defaultMessage: 'The note is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IBaseCostFormValues> => {
  return yup.object().shape({
    baseCosts: yup.array().of(
      yup.object().shape({
        amount: yup.number().nullable().required(intl.formatMessage(amountMessages.required)),
        capacity: yup.number().required()
      })
    ),
    note: yup.string().required(intl.formatMessage(noteMessages.required))
  })
}
